import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {ERROR, STATUS} from '../constant';

@Injectable()
export class ErrorService {
  error$: Observable<any>;

  constructor(private authService: AuthService, private store: Store<any>) {
    this.error$ = this.store.select('ERROR_REDUCER');

    this.error$
      .filter(state => state.status === STATUS.ERROR)
      .first()
      .subscribe(err => this.showErrorPage(err));
  }

  showErrorPage(err) {
    // SLACKERS-595: `err.data.payload` is frequently absent, and reading through
    // it unguarded threw before any redirect could happen. Read the status
    // defensively, and tag the UNKNOWN redirect so we can tell a failure routed
    // through the store apart from one routed through HttpService.handleError.
    const status = err && err.data && err.data.payload ? err.data.payload.status : undefined;

    if (status === 403) {
      window.location.href = ERROR.ACCESS_DENIED.url;
    } else if (status === 404) {
      window.location.href = ERROR.NOT_FOUND.url;
    } else if (status === 503) {
      window.location.href = ERROR.SERVICE_UNAVAILABLE.url;
    } else {
      const reported = status === undefined || status === null ? 'none' : String(status);
      window.location.href = `${ERROR.UNKNOWN.url}?status=${encodeURIComponent(reported)}&kind=store`;
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/service/error.service.ts